import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { DollarSign, Sparkles } from "lucide-react";

const RATE_FIELDS = [
  { key: "leadToOpportunity", label: "Lead → Opportunity", step: "0.01" },
  { key: "opportunityToProposal", label: "Opportunity → Proposal", step: "0.01" },
  { key: "proposalToClose", label: "Proposal → Close", step: "0.01" },
  { key: "averageDealSize", label: "Avg Deal Size ($)" },
];

export const CreateHierarchyModal = ({ open, onOpenChange, form, setForm, saving, onCreate }) => {
  const patch = (key) => (e) => setForm((prev) => ({ ...prev, [key]: e.target.value }));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#0d1117] border-gray-800 text-white max-w-lg" data-testid="create-hierarchy-modal">
        <DialogHeader>
          <DialogTitle className="text-xl text-white flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-ism-teal" /> Create Goal Hierarchy
          </DialogTitle>
          <DialogDescription className="text-gray-400">
            Set your revenue goal and conversion rates. The system will auto-calculate the pipeline, leads, and activities needed.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div>
            <label className="text-sm text-gray-400 mb-1 block">Revenue Goal</label>
            <div className="relative">
              <DollarSign className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500" />
              <Input type="number" value={form.revenueGoal} onChange={patch("revenueGoal")} className="pl-10 bg-white/5 border-gray-700 text-white" placeholder="1000000" data-testid="hierarchy-revenue-input" />
            </div>
          </div>
          <div>
            <label className="text-sm text-gray-400 mb-1 block">Target Date</label>
            <Input type="date" value={form.deadline} onChange={patch("deadline")} className="bg-white/5 border-gray-700 text-white" data-testid="hierarchy-deadline-input" />
          </div>
          <div className="pt-2 border-t border-gray-700">
            <p className="text-sm text-gray-400 mb-3">Conversion Rates (adjust based on your historical data)</p>
            <div className="grid grid-cols-2 gap-3">
              {RATE_FIELDS.map(({ key, label, step }) => (
                <div key={key}>
                  <label className="text-xs text-gray-500">{label}</label>
                  <Input type="number" step={step} value={form[key]} onChange={patch(key)} className="bg-white/5 border-gray-700 text-white text-sm" data-testid={`hierarchy-${key}-input`} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-gray-700 text-gray-300">Cancel</Button>
          <Button onClick={onCreate} disabled={saving} className="bg-ism-teal/20 text-ism-teal border border-ism-teal/30 hover:bg-ism-teal/30" data-testid="confirm-create-hierarchy-btn">
            {saving ? <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-white mr-2" /> : <Sparkles className="h-4 w-4 mr-2" />}
            Create Hierarchy
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
